import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import Warning from "TaskDialogCommon/Warning";
import StringList from "TaskDialogCommon/StringList";
import CitySelector from "TaskDialogCommon/CitySelector";

const taskname = "upgradebuildings";

export default function(props) {
  const { accountdetailrow, AccountDetailData } = props;
  const [taskConfig, setTaskConfig] = React.useState({
    accountdetail: accountdetailrow,
    userInputIncludeBuildingNames: [],
    targetcity: "",
    useHGS: true,
  });

  const validate = () => {
    if (taskConfig.targetcity === "") {
      alert("Please select a target city before continuing");
      return false;
    }
    return true;
  };

  const setValue = (event, key) => {
    let value = event.target.value;
    setTaskConfig({ ...taskConfig, [key]: value });
  };

  return (
    <TaskDialog heading={"Upgrade Buildings in City"}>
      <CitySelector
        label={"Select City To Upgrade"}
        AccountDetailData={AccountDetailData}
        taskConfig={taskConfig}
        setValue={setValue}
        param={"targetcity"}
      />
      <TaskCheckBox
        label={"Use Hourglasses"}
        param={"useHGS"}
        taskConfig={taskConfig}
        setValue={setValue}
      />
      <StringList
        label={`Open Upgrade Buildings Containing Following Names(Keep empty if you
                  want to do ALL buildings):`}
        taskConfig={taskConfig}
        param={"userInputIncludeBuildingNames"}
        setValue={setValue}
      />

      <Warning>
        *Make sure you have enough resources or the task will stop. <br />
        *Make sure you have enough hourglasses or the task will stop if you have
        selected using HGs.
      </Warning>

      <RunButton
        taskname={taskname}
        taskConfig={taskConfig}
        label={"Run Upgrade Buildings"}
        validate={validate}
      />
    </TaskDialog>
  );
}
